import React from 'react';
import { Grid, CircularProgress } from '@mui/material'
import "./Loader.scss";
const Loader = () => {
    return (
        <Grid container justifyContent="center" alignItems="center" className="center">
            <Grid item>
                <CircularProgress/>
            </Grid>
        </Grid>
    );
};

export default Loader;